import React, {ChangeEvent, FC} from "react";
import {CreateOrderTabProps} from "./OrderDetailsTab";
import {
    formatNames,
    isNullOrEmpty,
    reorderProperties,
    showToast,
    transformValueLabelToValue
} from "../../../helpers/utils/Utils";
import {useCreateOrderMutation} from "../ordersApi";
import {useNavigate} from "react-router-dom";
import {handleRTKQuery} from "../../../helpers/utils/RtkQueryUtils";
import InputField from "../../../components/common/form/InputField";
import ButtonTray from "../../../components/common/form/ButtonTray";


const FinishingTab: FC<CreateOrderTabProps> = ({createOrderData, setCreateOrderData, setTab}) => {

    const navigate = useNavigate()
    const [createOrder, createOrderApiResponse] = useCreateOrderMutation();

    const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
        const {name, type, value, checked} = e.target;

        setCreateOrderData({
            ...createOrderData,
            [name]: type === 'checkbox' ? checked : value,
        });
    };

    const handleCreateOrder = async () => {

        const updateList = {
            ...createOrderData,
            customerId: createOrderData?.customerId?.value,
            branchId: createOrderData?.branchId?.value,
            notes: createOrderData.note !== '' ? [createOrderData.note] : [],
            products: createOrderData.products?.map((p: any) => p?.value) || [],
            properties: createOrderData.properties.map((property: any) => ({
                ...property,
                propertyRequestSource: "CUSTOMER",
                address: transformValueLabelToValue(property.address),
                countyName: property?.countyName?.value,
                propertyType: property?.propertyType?.value
            }))
        }
        await handleRTKQuery(
            async () => {
                return await createOrder(updateList).unwrap();
            },
            (response: any) => {
                if (response?.errorCode == 200) {
                    const {id} = response;
                    setCreateOrderData({});
                    navigate(`/orders/${id}`);
                } else {
                    showToast(response?.message, "error");
                }
            }
        );
    };

    return (
        <div>
            <div className="p-5 bg-text-1 rounded-md order_finish_tab_Wrapper mt-5">
                <div className="grid grid-cols-3">
                    {[
                        {label: 'Order No.', value: createOrderData.orderNumber},
                        {
                            label: 'Buyer',
                            value: formatNames(createOrderData.buyers).length > 50 ? `${formatNames(createOrderData.buyers).slice(0, 50)}...` : formatNames(createOrderData.buyers)
                        },
                        {
                            label: 'Seller',
                            value: formatNames(createOrderData.sellers).length > 50 ? `${formatNames(createOrderData.sellers).slice(0, 50)}...` : formatNames(createOrderData.sellers)
                        },
                    ].map(({label, value}) => (
                        <div key={label}>
                            <h3 className="text-highlight-5 text-sm font-semibold">{label}</h3>
                            <h4 className="text-surface-=2 text-sm mt-2">{value || 'N/A'}</h4>
                        </div>
                    ))}
                </div>

                <div className="mt-5 grid grid-cols-3">

                    {[
                        {label: 'Customer', value: createOrderData.customerId?.label?.split('(')[0]},
                        {label: 'Branch', value: createOrderData.branchId?.label},
                        {label: 'Product', value: createOrderData.products?.map((obj: any) => obj.label).join(', ')}
                    ].map(({label, value}) => (
                        <div key={label}>
                            <h3 className="text-highlight-5 text-sm font-semibold">{label}</h3>
                            <h4 className="text-surface-=2 text-sm mt-2">{value || 'N/A'}</h4>
                        </div>
                    ))}
                </div>

                <div className="overflow-x-auto">
                    <table className="order_table_Wrapper min-w-full mt-5 table-auto">
                        <thead>
                        <tr>
                            <th className={'bg-highlight-0 text-text-0 text-left whitespace-nowrap font-semibold'}>#</th>
                            <th className={'bg-highlight-0 text-text-0 text-left whitespace-nowrap font-semibold'}>Tax
                                Account No.
                            </th>
                            <th className={'bg-highlight-0 text-text-0 text-left whitespace-nowrap font-semibold'}>Address</th>
                            <th className={'bg-highlight-0 text-text-0 text-left whitespace-nowrap font-semibold'}>State</th>
                            <th className={'bg-highlight-0 text-text-0 text-left whitespace-nowrap font-semibold'}>County</th>
                        </tr>
                        </thead>
                        <tbody>
                        {

                            createOrderData?.properties?.length > 0 && createOrderData?.properties?.map((curPackage: any, index: number) => {
                                return <tr className="even:bg-surface-7 hover:bg-surface-7" key={index}>
                                    <td className={"text-surface-0"}>{index + 1}</td>
                                    <td className={"text-surface-0"}>{curPackage.accountNumber}</td>
                                    <td className={"text-surface-0"}>{curPackage?.address?.streetAddress}</td>
                                    <td className={"text-surface-0"}>{curPackage?.address?.state?.label}</td>
                                    <td className={"text-surface-0"}>{curPackage?.countyName?.label}</td>
                                </tr>
                            })
                        }
                        </tbody>
                    </table>
                </div>
            </div>
            <div className=" grid-cols-12 mt-4 sm:block md:grid">
                <InputField
                    label="Closing Date"
                    value={createOrderData?.expectedClosingDate || ""}
                    placeholder="Enter closing Date..."
                    type="date"
                    name={"expectedClosingDate"}
                    onChange={handleOnChange}
                />

                <InputField
                    label="Need By Date"
                    value={createOrderData?.needByDate || ""}
                    placeholder="Enter Need By Date..."
                    type="date"
                    name={"needByDate"}
                    onChange={handleOnChange}
                />

                <InputField
                    label="Rush"
                    checked={createOrderData?.isRush}
                    placeholder="Enter Rush..."
                    type="checkbox"
                    name={"isRush"}
                    onChange={handleOnChange}
                />


                <InputField
                    label="Note"
                    value={createOrderData?.note}
                    placeholder="Enter Note..."
                    type="text"
                    name={"note"}
                    onChange={handleOnChange}
                />

            </div>

            <div className={"mt-3"}>
                <ButtonTray
                    buttons={[
                        {
                            buttonProps: {
                                btnText: "Previous",
                                onClick: () => setTab(2),
                                type: "close",
                            },
                            buttonType: "button"
                        },
                        {
                            buttonProps: {
                                btnText: "Submit",
                                onClick: () => {

                                    handleCreateOrder();

                                },
                                type: "button",
                                isLoading: (createOrderApiResponse?.isLoading),
                            },
                            buttonType: "button",
                        }
                    ]}
                    align={"end"}
                    gap={2}
                />
            </div>

        </div>
    )
}
export default FinishingTab